// spec 56 v8 §10 (D101 b, F325-F327, F428-F430, D102 a, D110 b): the floating add-to-cart bar. One IntersectionObserver
// whose root is the region above the screen: `data-above` while the buy box's add lies wholly inside it - a jump past
// the screen crosses the root's edge, so no report is missed (F429). `data-held` while the bar's own add holds the
// page's lock or the session it opened is open (F325), re-read at its add's admitted submit, at each report, at the
// popup's close and at a back/forward-cache restore (its listeners: the observer, the form's submit, the dialog's
// close, the window's pageshow). CSS shows the bar on either, or while it holds a message (D102 a, F430); hidden is
// visibility: hidden (F327's four properties, P4). The footer's page-end reserve keys on product-bar:defined (Gate 1):
// without this script (JavaScript off) there is none, and a bar whose add has no buy box form to submit removes
// itself, so a bar that can never show keeps no space.
if (!customElements.get("product-bar")) {
  customElements.define(
    "product-bar",
    class ProductBar extends HTMLElement {
      connectedCallback() {
        this.add = this.querySelector(".product-bar__add");
        this.form = this.add && this.add.form;
        this.coral = this.form && this.form.querySelector('[type="submit"]');
        if (!this.coral) {
          // no buy box form: the bar never shows, so it leaves the page and the footer's reserve with it (Gate 1)
          this.remove();
          return;
        }
        this.above = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            // the latest report: a notification task that runs late carries every report made before it, oldest first
            // (a page opened past the add: "below" at scroll 0, then "above" at the fragment, in one call)
            const entry = entries[entries.length - 1];
            // no root bounds in a cross-origin frame (the theme editor's preview): there the add is never "above"
            const root = entry.rootBounds;
            this.above = Boolean(root) && entry.isIntersecting && entry.boundingClientRect.bottom <= root.bottom;
            this.sync();
          },
          { rootMargin: "100000px 0px -100% 0px", threshold: [0, 1] }
        );
        this.observer.observe(this.coral);
        // product-form's submit listener is registered first (its script loads earlier): the lock already says
        // whether this bar's add was admitted
        this.onSubmit = (evt) => {
          if (evt.submitter === this.add) this.sync();
        };
        this.form.addEventListener("submit", this.onSubmit);
        // F428: after the shell's own close listener (added in its constructor), so its focus return lands first
        this.onClose = () => this.sync();
        customElements.whenDefined("cart-notification").then(() => {
          this.dialog = document.getElementById("cart-notification");
          if (this.dialog && this.isConnected) this.dialog.addEventListener("close", this.onClose);
        });
        // a page restored from the back/forward cache (Back from /cart after a bar add whose render failed, D69 a)
        // comes back with the hold its submit wrote: re-read it
        this.onPageShow = (evt) => {
          if (evt.persisted) this.sync();
        };
        window.addEventListener("pageshow", this.onPageShow);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.form) this.form.removeEventListener("submit", this.onSubmit);
        if (this.dialog) this.dialog.removeEventListener("close", this.onClose);
        if (this.onPageShow) window.removeEventListener("pageshow", this.onPageShow);
      }

      // F325: its add holds the lock, or opened the session that is open
      get held() {
        const form = customElements.get("product-form");
        const shell = document.querySelector("cart-notification");
        if (form && form.lock && form.lock.button === this.add) return true;
        return Boolean(shell && shell.sessionId && shell.session && shell.session.opener === this.add);
      }

      sync() {
        const held = this.held;
        const message = this.querySelector(".product-bar__message");
        const shown = this.above || held || Boolean(message && !message.hidden);
        if (!shown && this.contains(document.activeElement)) this.coral.focus({ preventScroll: true }); // D110 b
        this.toggleAttribute("data-above", this.above);
        this.toggleAttribute("data-held", held);
      }
    }
  );
}
